<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col md="12">
          <h5 class="section-label mb-3">
            {{ $t('Bills Payment Configurations') }}
          </h5>
        </b-col>
        <b-col
          md="12"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
          <validation-observer ref="billsPaymentRules">
            <b-form>
              <b-row class="match-height">
                <b-col
                  md="4"
                >
                  <InputField
                    id="fee-income-gl"
                    v-model="billsPaymentConfig.feeIncomeGL"
                    :label="$t('Fee Income GL')"
                    :placeholder="$t('Fee Income GL')"
                    rules="required"
                    type="text"
                    :error-name="$t('Fee Income GL')"
                  />
                </b-col>
                <b-col
                  md="4"
                >
                  <InputField
                    id="prepayment-gl"
                    v-model="billsPaymentConfig.prepaymentGL"
                    :label="$t('Prepayment GL')"
                    :placeholder="$t('Prepayment GL')"
                    rules="required"
                    type="text"
                    :error-name="$t('Prepayment GL')"
                  />
                </b-col>
                <b-col
                  md="4"
                >
                  <InputField
                    id="cash-back-expense-gl"
                    v-model="billsPaymentConfig.cashBackExpenseGL"
                    :label="$t('Cash Back Expense GL')"
                    :placeholder="$t('Cash Back Expense GL')"
                    rules="required"
                    type="text"
                    :error-name="$t('Cash Back Expense GL')"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <Button
                    v-if="getUserPermission('ADD_BILLS_PAYMENT_CONFIG')"
                    :label="$t('Save')"
                    size="lg"
                    class="mt-3"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    @click="handleSubmit"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </div>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BForm,
} from 'bootstrap-vue'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions, mapGetters } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../forms/InputField.vue'
import Button from '../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    Button,
    BForm,
    ValidationObserver,
    InputField,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      showSpinner: false,
      isLoading: false,
      isDisabled: false,
      sBusy: false,
      required,
      positive,
      endOfYearClosureList: [],
      billsPaymentConfig: {
        feeIncomeGL: '',
        prepaymentGL: '',
        cashBackExpenseGL: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
  },

  async mounted() {
    this.fetchBillPaymentConfiguration()
  },
  methods: {
    ...mapActions({
      billsPaymentConfiguration: 'eChannels/billsPaymentConfiguration',
      getBillPaymentConfiguration: 'eChannels/getBillPaymentConfiguration',
    }),
    async fetchBillPaymentConfiguration() {
      try {
        this.showSpinner = true
        const response = await this.getBillPaymentConfiguration({
          permission: eChannelsPermission.ADD_BILLS_PAYMENT_CONFIG,
        })
        const { data, status } = response
        if (status === 200 && data) {
          this.billsPaymentConfig = {
            feeIncomeGL: data.feeIncomeGL,
            prepaymentGL: data.prepaymentGL,
            cashBackExpenseGL: data.cashBackExpenseGL,
          }
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
        this.showSpinner = false
      }
    },
    handleSubmit() {
      this.$refs.billsPaymentRules.validate().then(success => {
        if (success) {
          this.confirm(this.saveBillsPaymentConfigurtion, { text: this.$t('Are you sure you want to Save this Bills Payment Configuration?') })
        }
      })
    },
    async saveBillsPaymentConfigurtion() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          ...this.billsPaymentConfig,
        }
        const response = await this.billsPaymentConfiguration({ formData, permission: eChannelsPermission.ADD_BILLS_PAYMENT_CONFIG })
        const { status } = response
        if (status === 200) {
          this.alertSuccess({ text: this.$t('Your request to Save Bills Payment Configuration was successful') })
        }
        this.isLoading = false
        this.isDisabled = false
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
  },
}
</script>
